import { motion } from "framer-motion";

interface MotionStepProps {
    children: React.ReactNode;
    [key: string]: any;
}
const MotionStep = ({ children, ...props }: MotionStepProps) => (
    <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        className="space-y-4"
        {...props}
    >
        {children}
    </motion.div>
);

export default MotionStep;